import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import {
  ConfirmationDetails,
  ConfirmationService,
} from "../../confirmation-dialog/confirmation.service";
import { PadlockService } from "../../padlock/padlock.service";
import { PadlockTokenState } from "../../padlock/state/padlock-token.reducer";
import { selectPadlockTokenState } from "../../padlock/state/padlock-token.selectors";
import { DeleteWorkspace } from "../state/workspaces.actions";
import { Workspace } from "../state/workspaces.model";
import { selectActiveWorkspace } from "../state/workspaces.selectors";

@Component({
  selector: "app-workspace-settings",
  templateUrl: "./workspace-settings.component.html",
  styleUrls: ["./workspace-settings.component.scss"],
  standalone: false,
})
export class WorkspaceSettingsComponent implements OnInit, OnDestroy {
  padlockTokenState$: Observable<PadlockTokenState> = this.store.select(
    selectPadlockTokenState,
  );
  padlockTokenState_: Subscription;
  userID: string;
  isPlatformAdmin: boolean = false;

  workspace$ = this.store.select(selectActiveWorkspace);
  workspace_: Subscription;
  workspace: Workspace;

  constructor(
    private store: Store<any>,
    private padlock: PadlockService,
    private confirm: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.padlockTokenState_ = this.padlockTokenState$.subscribe(() => {
      const decoded = this.padlock.getDecodedToken();
      this.userID = decoded ? decoded.sub : null;
      this.isPlatformAdmin = decoded?.platform_admin === true;
    });

    this.workspace_ = this.workspace$.subscribe((w) => {
      this.workspace = w;
    });
  }

  ngOnDestroy() {
    this.padlockTokenState_.unsubscribe();
    this.workspace_.unsubscribe();
  }

  delete() {
    const details: ConfirmationDetails = new ConfirmationDetails();
    details.title = `Are you sure you want to delete workspace, "${this.workspace.label}"?`;
    details.message = "You cannot undo this action.";
    details.buttonLabel = "Delete";
    details.destructiveButton = true;
    details.onConfirm = async () => {
      this.store.dispatch(new DeleteWorkspace(this.workspace));
    };
    this.confirm.confirm(details);
  }
}
